/**
 * used to specify how much a user agrees with a question
 */
export enum AgreementLevel {
  STRONGLY_DISAGREE = 'strongly_disagree',
  DISAGREE = 'disagree',
  NEUTRAL = 'neutral',
  AGREE = 'agree',
  STRONGLY_AGREE = 'strongly_agree',
}

/**
 * used to specify how much a user understands and owns a professional resources
 */
export enum ProfessionalResourceStatus {
  WHAT_IS_IT = 'what_is_it',
  NO = 'no',
  INCOMPLETE = 'incomplete',
  OUTDATED = 'outdated',
  UNPROFESSIONAL = 'unprofessional',
  YES = 'yes',
}

/**
 * used to specify a user's agreement or understanding
 */
export enum YesNoSomewhat {
  YES = 'yes',
  NO = 'no',
  SOMEWHAT = 'somewhat',
}

/**
 * payload to update the employment readiness assessment
 */
export type UpdateEmploymentReadinessDTO = Partial<{
  // ----------------------------------------
  // ----------------------------------------
  // 10: Do you agree with the following statements?

  agreeCanConductJobSearch: YesNoSomewhat;
  agreeKnowsStrengthsWeaknesses: YesNoSomewhat;
  agreeCollectsInformationAboutJobAndCompany: YesNoSomewhat;
  agreeHasPerformedInformationalInterviews: YesNoSomewhat;
  agreeMaintainsKnowledgeOnJob: YesNoSomewhat;
  agreeHasStrongReferences: YesNoSomewhat;
  agreeHasReviewedNetworkingStrategies: YesNoSomewhat;

  // ----------------------------------------
  // ----------------------------------------
  // Professional resources

  professionalResume: ProfessionalResourceStatus;
  professionalCoverLetter: ProfessionalResourceStatus;
  professionalProfile: ProfessionalResourceStatus;
  professionalEmail: ProfessionalResourceStatus;

  // ----------------------------------------
  // ----------------------------------------
  // Job interviews

  interviewPracticeIntroduction: AgreementLevel;
  interviewOnTime: AgreementLevel;
  interviewProvideDocuments: AgreementLevel;
  interviewExpressClearly: AgreementLevel;
  interviewProvideCompleteInformation: AgreementLevel;
  interviewRelevantQualification: AgreementLevel;
  interviewAskRelevantQuestions: AgreementLevel;
  interviewPositiveAttitude: AgreementLevel;
  interviewBodyLanguage: AgreementLevel;
  interviewFeelConfident: AgreementLevel;
  interviewAppropriateLanguage: AgreementLevel;
  interviewRespondsAppropriately: AgreementLevel;
  interviewInitiateCompleteTasks: AgreementLevel;
  interviewIntegrity: AgreementLevel;
  interviewClothingAppropriate: AgreementLevel;
  interviewClothingProfessional: AgreementLevel;

  // ----------------------------------------
  // ----------------------------------------
  // work attitude

  attitudeTakeResponsibility: AgreementLevel;
  attitudeGainsKnowledge: AgreementLevel;
  attitudeWorkLongHours: AgreementLevel;
  attitudeSatisfactionFromWork: AgreementLevel;
  attitudeFollowSchedule: AgreementLevel;
  attitudePunctual: AgreementLevel;
  attitudeCompleteTasksOnTime: AgreementLevel;
  attitudePoliteAtWork: AgreementLevel;
  attitudeExpressesOpinionsClearly: AgreementLevel;
  attitudeCommunicatesWithManager: AgreementLevel;
  attitudeResolvesConflict: AgreementLevel;
  attitudeAppropriateLanguage: AgreementLevel;
  attitudeRespondsAppropriately: AgreementLevel;
  attitudeInitiateCompleteTasks: AgreementLevel;
  attitudeIntegrity: AgreementLevel;
}>;
